import { Product, Variant } from '@gate31/types';

export class InsalesProduct {
    product: Product;
    constructor(product: Product) {
        this.product = product;
    }
    get id() {
        return this.product.id;
    }

    get title() {
        return this.product.title;
    }

    get url() {
        return this.product.url;
    }

    get variants() {
        return this.product.variants;
    }

    hasVariant(optionValueSizePositionId: string) {
        return this.product.variants.some((variant: Variant) => {
            const targetOptionValues = variant?.option_values?.find(item => item.option_name_id === InsalesProduct.SIZE_OPTION_ID);

            return targetOptionValues?.position === Number(optionValueSizePositionId);
        });
    }

    variantAvailable(optionValueSizePositionId: string) {
        return this.product.variants.some((variant: Variant) => {
            const targetOptionValue = variant?.option_values?.find(item => item.option_name_id === InsalesProduct.SIZE_OPTION_ID);

            if (targetOptionValue?.position === Number(optionValueSizePositionId)) {
                return variant.available;
            }
        });
    }

    getColorName() {
        const characteristic = this.product.characteristics
            .find(item => item.property_id === InsalesProduct.PROPERTY_COLOR_ID);

        if (characteristic) {
            return characteristic.title;
        }

        return null;
    }

    static SIZE_OPTION_ID = 788084 as const;
    static PROPERTY_COLOR_ID = 2445476 as const;
}
